//Clase de la aplicacion BextDocUI
//Autor:Marlon Granda-Fecha:25/21/2019 - Mail:mar_gran2003@yahoo.com.ar
//Empresa:Marlon Granda

import { Component, ViewChild, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Paginas, ControllerMethods } from '../../../models/general.enum';
import { Utilities } from '../../../helpers/utilities';
import { ModalNotifyComponent, ModalNotifyTypes } from '../../../components/modal-notify/modal-notify.component';
import { BaseServiceService } from '../../../services/base-service.service'
import { BaseCrud } from '../../../bussines/base-crud';
import { ContextMenuComponent } from 'ngx-contextmenu';
import { StaticData } from 'src/app/helpers/static-data';
import { AdminPermisosComponent } from '../../admin-permisos/admin-permisos.component';


@Component({
	selector: 'app-rpagina',
	templateUrl: './rpagina.component.html',
	styleUrls: ['./rpagina.component.css']
})
export class RPaginaComponent extends BaseCrud implements OnInit {

	@ViewChild(ContextMenuComponent, { static: true }) public basicMenu: ContextMenuComponent;

	@ViewChild("permisos", { static: false }) public adminPermisosComponent: AdminPermisosComponent;
	adminPermisos: boolean = true;
	imagenEditorJson: string = '';
	imagenAEditorAce: string = '';
	isNewPage: boolean = false;


	constructor(public baseService: BaseServiceService, public utility: Utilities) {

		super(baseService, utility, Paginas.Pagina, 'RPagina', null, false);
		this.pkName = 'IdPagina';
	}

	public Clonar() {
		this.modelo.PkValue = 0;
		this.modelo[this.pkName] = 0;
		this.SetProcesando(false);
	}
	public VerEditor(tipo: any, prop: string) {

		debugger;
		let tempModel: any = {};

		if (this.modelo && this.modelo[prop]) {
			let config = this.modelo[prop].replace('\"', '"');
			tempModel = JSON.parse(config);
		}
		this.utility.VerEditor(tipo, tempModel, false, "Editor  [" + prop + ']').then(data => {
			if (data.dialogResult == true) {
				this.modelo[prop] = JSON.stringify(data.modelo);
				this.ExcecuteFuntion(ControllerMethods.Edit, true, this.modelo);
			}
		});

	}
	public onSpecificStart() {
		this.imagenEditorJson = this.utility.GetPathImages(this.utility.GetNodeType('EditorJson'));
		this.imagenAEditorAce = this.utility.GetPathImages(this.utility.GetNodeType('EditorAce'));
		this.isAddEventsColumns = true;
		this.conFiltroIdEmpresa = true;
		this.itemsSelectControls['ItemsIdPaginaPadre'] = [];
		this.configs = {};
		this.cargarGrilla = true;
		this.hideDataTable = false;
		//this.configs.ConfigIdPaginaPadre = { 'SetCargarItems': true, 'Controller': 'RPagina', 'Params': { 'Activo': true, 'IdEmpresa': -1 } };
		//this.configs.ConfigSearchIdPaginaPadre = { 'PagedServer': true, 'SearchParam': 'Nombre', 'ViewFieldModel': 'Nombre', 'SetLike': true, 'Include': {}, 'Params': { 'IdEmpresa': -1 }, 'Controller': 'RPagina', 'Filter': 'Activo=1', 'MappingFields': { 'IdPagina': 'IdPagina' }, 'Columns': ['IdPagina', 'Nombre'], 'Props': ['IdPagina', 'Nombre'] };

		this.columns = [{ data: this.pkName, title: 'Id' },
		// { data: 'IdPaginaPadre', title: 'Pagina Padre' },
		{ data: 'Nombre', title: 'Nombre' },
		{ data: 'Titulo', title: 'Titulo' },
			// { data: 'Ruta', title: 'Ruta' },
			// { data: 'Controlador', title: 'Controlador' },
			//this.GetBooleanColumn('Es Para Menu', 'Es Para Menu', 'EsParaMenu', 'IdPagina', 'EsParaMenu', null, false),
			//this.GetBooleanColumn('Es Para Permisos', 'Es Para Permisos', 'EsParaPermisos', 'IdPagina', 'EsParaPermisos', null, false),
			//this.GetBooleanColumn('Es Movil', 'Es Movil', 'EsMovil', 'IdPagina', 'EsMovil', null, false),
			/* this.GetBooleanColumn('Filtro', 'Filtro', 'Filtro', 'IdPagina', 'Filtro', null, false),
			this.GetBooleanColumn('Exportar', 'Exportar', 'Exportar', 'IdPagina', 'Exportar', null, false),
			this.GetBooleanColumn('Guardar', 'Guardar', 'Guardar', 'IdPagina', 'Guardar', null, false),
			this.GetBooleanColumn('Editar', 'Editar', 'Editar', 'IdPagina', 'Editar', null, false),
			this.GetBooleanColumn('Eliminar', 'Eliminar', 'Eliminar', 'IdPagina', 'Eliminar', null, false),
			this.GetBooleanColumn('Importar', 'Importar', 'Importar', 'IdPagina', 'Importar', null, false),
			this.GetBooleanColumn('Consultar', 'Consultar', 'Consultar', 'IdPagina', 'Consultar', null, false),
			//this.GetBooleanColumn('Con Modal Crud', 'Con Modal Crud', 'ConModalCrud', 'IdPagina', 'ConModalCrud', null, true),
			this.GetBooleanColumn('Ver Comfirmar Guardar', 'Ver Comfirmar Guardar', 'VerComfirmarGuardar', 'IdPagina', 'VerComfirmarGuardar', null, false),
			this.GetBooleanColumn('Ver Comfirmar Limpiar', 'Ver Comfirmar Limpiar', 'VerComfirmarLimpiar', 'IdPagina', 'VerComfirmarLimpiar', null, false),
			this.GetBooleanColumn('Ver Comfirmar Editar', 'Ver Comfirmar Editar', 'VerComfirmarEditar', 'IdPagina', 'VerComfirmarEditar', null, false),
			this.GetBooleanColumn('Ver Comfirmar Eliminar', 'Ver Comfirmar Eliminar', 'VerComfirmarEliminar', 'IdPagina', 'VerComfirmarEliminar', null, false), */
			//this.GetBooleanColumn('Is Custom', 'Is Custom', 'IsCustom', 'IdPagina', 'IsCustom', null, false),
		];

		this.preSaveEmitter.subscribe(event => {
			debugger;
			this.isNewPage = !event.IsEdit;
		})
		this.postSaveEmitter.subscribe(event => {
			debugger;
			if (this.isNewPage)
				StaticData.Usuario.Paginas.push(event.data.data);
		})
		this.postEditEmitter.subscribe(event => {
			debugger;
			this.SetAdminPermisos();
		})
		this.postSave = this.postSaveFunt;
	}//
	public postSaveFunt(model: any): void {


	}
	public Limpiar(callback: (data: any) => void = null) {
		this.modelo = {};
		this.modelo.IdPagina = 0;
		this.modelo.PkValue = 0;
		this.modelo.IdEmpresa = -1;
		this.modelo.IdPaginaPadre = null;
		this.modelo.Nombre = '';
		this.modelo.Titulo = '';
		this.modelo.Descripcion = null;
		this.modelo.Ruta = 'General';
		this.modelo.Url = 'General.html';
		this.modelo.ModalUrl = null;
		this.modelo.Controlador = 'GeneralController';
		this.modelo.EsParaMenu = true;
		this.modelo.EsParaPermisos = true;
		this.modelo.EsMovil = true;
		this.modelo.Filtro = true;
		this.modelo.Exportar = true;
		this.modelo.Guardar = true;
		this.modelo.Editar = true;
		this.modelo.Eliminar = true;
		this.modelo.Importar = true;
		this.modelo.Consultar = true;
		this.modelo.Configuracion = null;
		this.modelo.ConModalCrud = null;
		this.modelo.VerComfirmarGuardar = true;
		this.modelo.VerComfirmarLimpiar = true;
		this.modelo.VerComfirmarEditar = true;
		this.modelo.VerComfirmarEliminar = true;
		this.modelo.ConfiguracionFiltro = null;
		this.modelo.IsCustom = true;
		this.modelo.UsuariosPermitidos = null;
		this.modelo.RolesPermitidos = null;
		this.modelo.AreasEmpresaPermitidas = null;
		this.modelo.GruposPermitidos = null;
		this.modelo.ConfiguracionPermisos = null;
		this.modelo.Activo = true;
		this.utility.SetFieldsToModel(this.modelo, this.filterParent);
		if (callback) callback(this.modelo);
	}

	public SetAdminPermisos() {

		if (this.adminPermisosComponent) {
			this.adminPermisosComponent.SetModelo(this.modelo);
		}
	}



	view: any[] = [700, 400];

	// options
	showXAxis = true;
	showYAxis = true;
	gradient = false;
	showLegend = true;
	showXAxisLabel = true;
	xAxisLabel = 'Country';
	showYAxisLabel = true;
	yAxisLabel = 'Population';

	colorScheme = {
		domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
	};
	onSelect(event) {
		console.log(event);
	}

	single: any[] = [
		{
			"name": "Germany",
			"value": 8940000
		},
		{
			"name": "USA",
			"value": 5000000
		},
		{
			"name": "France",
			"value": 7200000
		}
	];

}
